import { useState, useEffect } from 'react'

import { preferentialService } from '../services'

const usePreferential = () => {
  const [preferentials, setPreferentials] = useState<any[]>([])

  useEffect(() => {
    getPreferentialsCurrent()
  }, [])

  const getPreferentialsCurrent = async () => {
    const resp = await preferentialService.getCurrent()
    setPreferentials(resp.data)
  }

  return {
    preferentials
  }
}

export { usePreferential }